import { ApiService } from '../apiService'
import { ApiResponse } from '../types/common'
import {
  AdventureClueDto,
  CreateClueRequest,
  UpdateClueRequest,
  ClueSettingsDto,
  ClueStatusDto,
  ClueRequestResponseDto,
} from '../types/clues'

export const cluesApi = {
  // ========================
  // Creator: Clue Management
  // ========================

  // Get all clues for an adventure
  getClues: (adventureId: string) =>
    ApiService.get<AdventureClueDto[]>(`/api/adventures/${adventureId}/clues`),

  // Create a new clue
  createClue: (adventureId: string, data: CreateClueRequest) =>
    ApiService.post<ApiResponse<AdventureClueDto>>(`/api/adventures/${adventureId}/clues`, data),

  // Update an existing clue
  updateClue: (adventureId: string, clueId: string, data: UpdateClueRequest) =>
    ApiService.put<ApiResponse<AdventureClueDto>>(`/api/adventures/${adventureId}/clues/${clueId}`, data),

  // Delete a clue
  deleteClue: (adventureId: string, clueId: string) =>
    ApiService.delete<ApiResponse<void>>(`/api/adventures/${adventureId}/clues/${clueId}`),

  // ========================
  // Creator: Clue Settings
  // ========================

  // Get clue settings for an adventure
  getSettings: (adventureId: string) =>
    ApiService.get<ClueSettingsDto>(`/api/adventures/${adventureId}/clues/settings`),

  // Update clue settings
  updateSettings: (adventureId: string, data: Partial<ClueSettingsDto>) =>
    ApiService.put<ApiResponse<ClueSettingsDto>>(`/api/adventures/${adventureId}/clues/settings`, data),

  // ========================
  // Player: Session Clues
  // ========================

  // Get clue status for current session
  getClueStatus: (sessionId: string) =>
    ApiService.get<ClueStatusDto>(`/api/sessions/${sessionId}/clues/status`),

  // Request a clue (pull model)
  requestClue: (sessionId: string) =>
    ApiService.post<ClueRequestResponseDto>(`/api/sessions/${sessionId}/clues/request`),
}
